import { Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';
 
/**
* iOS Minus Button Directive
* Adds minus button to iOS decimal keyboard and validates minus position
* Only active on iOS devices (detected via window.iosKbInjected set by native handler)
* Usage: <input appIosMinusButton type="text" />
*/
@Directive({ selector: 'input[appIosMinusButton], textarea[appIosMinusButton]' })
export class IosMinusButtonDirective implements OnInit, OnDestroy {
  private readonly element = this.el.nativeElement;
  private inputHandler?: (event: Event) => void;
 
  constructor(private el: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {}
 
  ngOnInit(): void {
    if (window.localStorage.getItem('deviceType') !== 'iOS') return;
 
    const element = this.element;
    element.setAttribute('data-ios', 'minusButton');
    element.inputMode = 'decimal';
 
    if (element instanceof HTMLInputElement && element.type === 'number') {
      element.setAttribute('type', 'text');
    }
 
    this.inputHandler = () => {
      const value = element.value;
      if (!value) return;
      
      const firstChar = value[0];
      const minusIndex = value.indexOf('-');
      const firstDotIndex = value.indexOf('.');
      
      let newValue = value;
      let changed = false;
      
      // Only allow one minus at the beginning
      if (minusIndex !== -1 && (minusIndex > 0 || value.lastIndexOf('-') !== minusIndex)) {
        newValue = firstChar === '-' 
          ? '-' + newValue.replace(/-/g, '') 
          : newValue.replace(/-/g, '');
        changed = true;
      }
      
      // Only allow one dot
      if (firstDotIndex !== -1 && value.lastIndexOf('.') !== firstDotIndex) {
        const beforeDot = newValue.substring(0, firstDotIndex + 1);
        const afterDot = newValue.substring(firstDotIndex + 1).replace(/\./g, '');
        newValue = beforeDot + afterDot;
        changed = true;
      }
      
      if (changed) {
        element.value = newValue;
        element.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };
 
    element.addEventListener('input', this.inputHandler);
  }
 
  ngOnDestroy(): void {
    if (this.inputHandler) {
      this.element.removeEventListener('input', this.inputHandler);
    }
  }
}